import is from '@sindresorhus/is';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { jobPageUrl } from '../pages/job-list/constants';
import { userProfileUrl } from '../pages/profile/constants';
import { getSkillDetailsPageUrl } from '../pages/skill-details/constants';

export const useNavigationToEntity = (): {
    readonly navigateToJobPage: (jobId: string) => void;
    readonly navigateToJobProfilePage: (jobProfileId: string, from?: string) => void;
    readonly navigateToLearningOpportunityPage: (learningOpportunityId: string, from?: string) => void;
    readonly navigateToSkillPage: (skillId: string) => void;
    readonly navigateToUserProfile: (userId: string) => void;
} => {
    const { actions } = useContext(ApplicationContext);

    const navigateToUserProfile = (userId: string): void => actions.navigateTo(userProfileUrl(userId));

    const navigateToSkillPage = (skillId: string): void => actions.navigateTo(getSkillDetailsPageUrl(skillId));

    const navigateToJobPage = (jobId: string): void => actions.navigateTo(jobPageUrl(jobId));

    const navigateToLearningOpportunityPage = (
        learningOpportunityId: string,
        from: string | undefined = undefined,
    ): void => {
        if (is.nonEmptyString(from)) {
            actions.navigateTo(`/learning-opportunities/${learningOpportunityId}?from=${from}`);

            return;
        }
        actions.navigateTo(`/learning-opportunities/${learningOpportunityId}`);
    };

    const navigateToJobProfilePage = (jobProfileId: string, from: string | undefined = undefined): void => {
        if (is.nonEmptyString(from)) {
            actions.navigateTo(`/job-profiles/${jobProfileId}?from=${from}`);

            return;
        }
        actions.navigateTo(`/job-profiles/${jobProfileId}`);
    };

    return {
        navigateToJobPage,
        navigateToJobProfilePage,
        navigateToLearningOpportunityPage,
        navigateToSkillPage,
        navigateToUserProfile,
    };
};
